












































import _ from 'lodash';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { State, Action, namespace } from 'vuex-class';
import {
    ActionError as campaignStoreErr,
    CurrentCampaignType,
    CurrentAdsetType,
} from '@/store/campaign/types';

import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';
import { EditAdset as feedbackTerms } from '@/const/terms/feedback/adset';
import { SetCampaign as campaignFeedback} from '@/const/terms/feedback/campaign';

import { ID_TYPE, IAPP, AD_FORMAT_RAW_TYPE, AD_FORMAT, AD_FORMAT_KEY, ADJUSTMENT_TYPE } from '@/const/types';
import { STATUS } from '@/const/status';
import { AD_FORMAT_MAP } from '@/const/options/index';
import { IAudienceData } from '@/pages/audience/types';
import {
    FormType,
    IInventory,
    IImpressionSchedule,
    AdsetResponse,
    FormResponse,
    InventoryResponse,
    INativeInventory,
} from './editingTypes';
import { InitialSchedule, InitialFormData, InitialInventoryData } from './editingData';
import { AdsetResponse as AdsetSummaryResponse, IAdsetSummary, IAdsetBrief } from './types'
import { CampaignInfoResponse } from '../editingTypes';
import { InitialFormData as InitialCampaignInfoData} from '../editingData';

import { Form as ElForm, Table as ElTable} from 'element-ui';
import { AxiosError, AxiosResponse } from 'axios';

import AdsetForm from '@/components/pages/adset/AdsetForm.vue';
import AdsetEditingBrief from '@/components/pages/adset/AdsetEditingBrief.vue';

import { INVENTORY_TYPE } from '../../../const/types';

const campaignModule = namespace('Campaign');

@Component<AdsetEdit>({
    name: 'AdsetEdit',
    components: {
        AdsetForm,
        AdsetEditingBrief,
    },
    beforeRouteLeave (to: any, from: any, next: any) {
        if (this.isSubmit || to.name === 'login') {
            next();
        } else {
            this.$confirm(feedbackTerms.other.confirm.warnIsModified,'Warning', {
                confirmButtonText: '네',
                cancelButtonText: '아니오',
                type: 'warning'
            }).then((confirm: any) => {
                next();
            })
            .catch(() => {})
        }
    }
})
export default class AdsetEdit extends Vue {
    private terms = terms;
    private compTerms = compTerms;

    private isSubmit: boolean = false;
    private loading: boolean = false;
    
    private campaignData: CampaignInfoResponse  = _.cloneDeep(InitialCampaignInfoData);    
    private inventoryList: IInventory[] = [];

    private form: FormType = _.cloneDeep(InitialFormData);

    get whichLocation() {
        return this.$route.path.split('/').splice(-1, 1)[0].toLowerCase();
    }

    get isEdit() {
        return (this.$route.params && this.$route.params.adsetGroup && true) === true;
    }

    @campaignModule.State('currentCampaign') private currentCampaign!: CurrentCampaignType;
    @campaignModule.State('currentAdset') private currentAdset!: CurrentAdsetType;
    @campaignModule.Action('SET_CURRENT_ADSET') private setCurrentAdset: any;
    @campaignModule.Action('CLEAR_CURRENT_ADSET') private clearCurrentAdset: any;
    @campaignModule.Action('SET_CURRENT_CAMPAIGN') private setCurrentCampaign!: any;
    
    private cancel() {
        this.$router.push({name: 'adset', params: this.$route.params});
    }

    private submitProcess(){
        const adsetForm = this.$refs.adsetForm as AdsetForm;
        const form = adsetForm.$refs.form as ElForm;
        form.validate().then((valid: boolean) => {
            if (valid) {
                this.loading = true;
                if (this.isEdit) {
                    this.submitForEditHandler(form);
                } else {
                    this.submitForNewHandler(form);
                }
            } else {
                return false;
            }
        }).catch((err: boolean) => {
            if (err === false) {
                const errorField = (form as any).fields.find((f: any) => f.validateState === 'error') as Vue;
                if (errorField) {
                    const el = errorField.$el.querySelector('input') as HTMLElement;
                    el.focus();
                }
            }
        })
    }

    private submitForEditHandler(form: ElForm) {
        this.submitForEdit(form.model as FormType).then((res: any) => res.data)
            .then((data: {result: boolean, status?: number}) => {
                if (data && data.result) {
                    this.$notify.success(feedbackTerms.editing.success);
                    this.isSubmit = true;
                    this.$router.push({name: 'adset', params: {
                        campaignID: this.currentCampaign.id as string,
                    }});
                    return;
                }
                if (data.hasOwnProperty('status') && data.status === 2) {
                    const errorField = (form as any).fields.find((f: any) => f.prop === 'name') as Vue;
                    if (errorField) {
                        const el = errorField.$el.querySelector('input') as HTMLElement;
                        el.focus();
                    }
                    throw new Error(feedbackTerms.editing.error.duplicatedName);
                    return;
                }
                throw new Error(feedbackTerms.editing.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.editing.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(() => {this.loading = false})
    }

    private submitForEdit(model: FormType): Promise<any> {
        return this.$http.adserverAPI.post('UpdateAdsetInfo', {
            campaign_id: this.currentCampaign.id,
            name: model.name.trim(),
            adsets: (model.targets as IInventory[]).map((item: IInventory) => {
                item.price.type === ADJUSTMENT_TYPE.FREE && (item.price.value = 0);
                (!model.budget) && (item.budget = 0);
                (!model.impressionSchedule.isUsed) && (model.impressionSchedule.impSchedule = _.cloneDeep(InitialSchedule));
                return {
                    id: item.id,
                    placement_id: item.placement_id,
                    status: item.status,
                    landingUrl: item.landingURL,
                    trackingUrl: item.trackingURL,
                    type: item.type,
                    name: item.name,
                    price: item.price,
                    budget: item.budget,
                    native_info: (item as INativeInventory).native_info,
                }
            }),
            beginDate: model.date[0] ? (model.date[0] as Date).getTime() : null,
            endDate: model.date[1] ? (model.date[1] as Date).getTime() : null,
            audienceList: model.audience.map((aud: IAudienceData) => aud.id),
            impressionSchedule: model.impressionSchedule,
        })
    };
    // private submitForEdit = (model: FormType) => Promise.resolve(true);
    
    private submitForNewHandler(form: ElForm) {
        this.submitForNew(form.model as FormType).then((res: any) => res.data)
            .then( async (data: {result: boolean, adset_ids: {[placementID: string]: ID_TYPE}, status?: number}) => {
                if (data && data.result) {
                    try {
                        const idList = Object.values(data.adset_ids).map((item: ID_TYPE) => item) as ID_TYPE[];
                        await this.setCurrentAdset({
                            idList: idList,
                            name: this.form.name,
                        });
                        this.$notify.success(feedbackTerms.new.success);
                        this.isSubmit = true;
                        this.$router.push({
                            name: 'adInit',
                            params: { 
                                campaignID: this.$route.params.campaignID,
                                adsetGroup: this.currentAdset.name,
                            },
                        });
                        return;
                    } catch (err) {
                        switch (err.type) {
                            case campaignStoreErr.SET_CURRENT_CAMPAIGN:
                                throw new Error(feedbackTerms.new.error.setCurrentAdset.message);
                                break;
                        }
                        throw err;
                    }
                }
                
                if (data.hasOwnProperty('status') && data.status === 2) {
                    const errorField = (form as any).fields.find((f: any) => f.prop === 'name') as Vue;
                    if (errorField) {
                        const el = errorField.$el.querySelector('input') as HTMLElement;
                        el.focus();
                    }
                    throw new Error(feedbackTerms.new.error.duplicatedName);
                    return;    
                }
                throw new Error(feedbackTerms.new.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse ).status !== 200) {
                    this.$notify.error(feedbackTerms.new.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(()=>{this.loading=false})
    }

    private submitForNew(model: FormType): Promise<any> {
        return this.$http.adserverAPI.post('CreateAdsets', {
            campaign_id: this.currentCampaign.id,
            name: model.name.trim(),
            adsets: (model.targets as IInventory[]).map((item: IInventory) => {
                item.price.type === ADJUSTMENT_TYPE.FREE && (item.price.value = 0);
                (!model.budget) && (item.budget = 0);
                (!model.impressionSchedule.isUsed) && (model.impressionSchedule.impSchedule = _.cloneDeep(InitialSchedule));
                return {
                    id: item.placement_id,
                    status: item.status,
                    landingUrl: item.landingURL,
                    trackingUrl: item.trackingURL,
                    type: item.type,
                    name: item.name,
                    price: item.price,
                    budget: item.budget,
                    native_info: item.type === INVENTORY_TYPE.native ? (item as INativeInventory).native_info : undefined,
                }
            }),
            beginDate: model.date[0] ? (model.date[0] as Date).getTime() : null,
            endDate: model.date[1] ? (model.date[1] as Date).getTime() : null,
            audienceList: model.audience.map((aud: IAudienceData) => aud.id),
            impressionSchedule: model.impressionSchedule,
        });
    };
    // private submitForNew = (model: FormType) => Promise.resolve(true);

    private setScheduleDefault() {
        this.form.impressionSchedule = {
            isUsed: this.form.impressionSchedule.isUsed, 
            impSchedule: _.cloneDeep(InitialSchedule),
        };
    }
    
    private async initData() {
        const campaignID = this.$route.params.campaignID;
        this.loading = true;
        await this.getCampaignData(campaignID).then((res: any) => res.data)
            .then(async (data: CampaignInfoResponse) => {
                if (data && (data as any).result === null) {
                    throw new Error(campaignFeedback.getResponse.error.notFound);
                }
                try {
                    await this.setCurrentCampaign({
                        id: data.id,
                        name: data.name,
                        app: data.app,
                    });
                    this.campaignData = { ...data };
                    this.campaignData.date = [(data.beginDate ? new Date(data.beginDate) : ''), (data.endDate ? new Date(data.endDate) : '')];
                } catch (err) {
                    switch (err.type) {
                        case campaignStoreErr.SET_CURRENT_CAMPAIGN:
                            throw new Error(campaignFeedback.getResponse.error.setCurrentCampaign);
                            break;
                    }
                    throw new Error(campaignFeedback.getResponse.error.fail);
                }
                this.setScheduleDefault();
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(campaignFeedback.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                    this.isSubmit = true;
                    this.$router.push({name: 'campaign'});
                }
                throw null;
            })
            .then(() => {
                if (this.isEdit) {
                    if (this.currentAdset.name !== this.$route.params.adsetGroup) {
                        try {
                            return this.searchAdsetGroup(this.$route.params.adsetGroup);
                        } catch (err) {
                            switch (err.type) {
                                case campaignStoreErr.SET_CURRENT_CAMPAIGN:
                                    throw new Error(feedbackTerms.new.error.setCurrentAdset.message);
                                    break;
                            }
                            throw err;
                        }
                    }
                } else {
                    this.clearCurrentAdset();
                }
            })
            .then(() => {
                if (this.isEdit) {
                    return this.getAdsetDataHandler();
                } else {
                    return this.getInventoryDataHandler();
                }
            })
            .catch((err: AxiosError) => {
                if (err === null) {
                    throw err;
                }
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(campaignFeedback.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                    this.isSubmit = true;
                    this.$router.push({name: 'adset', params: {campaignID: this.currentCampaign.id.toString()}});
                }
                throw err;
            })
            .finally(()=>{this.loading = false})
    
    }
    private searchAdsetGroup(groupName: string) {
        return this.$http.adserverAPI.post('GetAdsetReport', {
            campaign_id: this.currentCampaign.id,
            placements: ['1','2','3','4','5','6'],
            since: moment(Date.now()).format('YYYYMMDDHH'),
            until: moment(Date.now()).format('YYYYMMDDHH'),
        }).then((res: any) => res.data)
            .then( async (data: AdsetSummaryResponse) => {
                const target = data.adsets.find((adset: IAdsetSummary) => adset.name === groupName)
                if (target) {
                    await this.setCurrentAdset({
                        idList: target.targets.map((inv: IAdsetBrief) => inv.adset_id),
                        name: target.name
                    })
                } else {
                    throw new Error(feedbackTerms.editing.error.notFound);
                }
            })
    }
    private getAdsetDataHandler() {
        return  this.getAdsetData().then((res: any) => res.data)
                    .then((data: FormResponse) => {
                        this.form.name = data.name;
                        this.form.isLegacy = false;
                        if (data.name.includes('-')) {
                            this.form.isLegacy = true;
                        }
                        this.inventoryList = data.adsets.map((adset: AdsetResponse) => {
                            adset.format = [] as AD_FORMAT[];
                            if (adset.format_raw) {
                                adset.format = adset.format_raw.map((f: AD_FORMAT_RAW_TYPE) => {
                                    const key = AD_FORMAT_KEY(adset.type, f.width, f.height);
                                    return AD_FORMAT[key];
                                })
                            }
                            const disabled =    adset.format.length === 0 ||
                                                AD_FORMAT_MAP[adset.type] === undefined ||
                                                AD_FORMAT_MAP[adset.type][adset.sspFormat] === undefined ||
                                                adset.format.reduce((pre: boolean, f: AD_FORMAT) => {
                                                    return pre && (AD_FORMAT_MAP[adset.type][adset.sspFormat][f] !== undefined)
                                                }, true) === false;
                            return {
                                ...adset,
                                landingURL: adset.landingUrl,
                                trackingURL: adset.trackingUrl,
                                disabled: disabled,
                            } as IInventory
                        })
                        .sort((a: IInventory, b: IInventory) => {
                            if (a.disabled && !b.disabled) return 1;
                            if (!a.disabled && b.disabled) return -1;
                            return a.name < b.name ? -1 : 1;
                        });
                        this.form.date = [data.beginDate ? new Date(data.beginDate) : '', data.endDate ? new Date(data.endDate) : ''];
                        this.form.targetInventory = data.targetInventory;
                        this.form.budget = data.budget;
                        this.form.audience = data.audience;
                        this.form.impressionSchedule.isUsed = data.impressionSchedule.isUsed;
                        data.impressionSchedule.impSchedule && data.impressionSchedule.impSchedule.forEach((item: IImpressionSchedule) => {
                            this.form.impressionSchedule.impSchedule[item.day].schedule = item.schedule;
                        })
                    })
                    .catch((err: AxiosError) => {
                        if (err.response && (err.response as AxiosResponse).status !== 200) {
                            this.$notify.error(feedbackTerms.editing.error.getResponse);
                        } else {
                            this.$notify.error(err.message);
                        }
                        throw err;
                    })
    }

    private getInventoryDataHandler() {
        return  this.getInventoryData((this.campaignData.app as IAPP).key).then((res: any) => res.data)
                    .then((data: InventoryResponse[]) => {
                        this.inventoryList = data.map((item: InventoryResponse) => {
                            item.format = [] as AD_FORMAT[];
                            if (item.format_raw) {
                                item.format = item.format_raw.map((f: AD_FORMAT_RAW_TYPE) => {
                                    const key = AD_FORMAT_KEY(item.type, f.width, f.height);
                                    return AD_FORMAT[key];
                                })
                            }
                            const disabled =    item.format.length === 0 ||
                                                AD_FORMAT_MAP[item.type] === undefined ||
                                                AD_FORMAT_MAP[item.type][item.sspFormat] === undefined ||
                                                item.format.reduce((pre: boolean, f: AD_FORMAT) => 
                                                    (pre && (AD_FORMAT_MAP[item.type][item.sspFormat][f] !== undefined))
                                                , true) === false;

                            if (item.selected) {
                                this.form.targetInventory.push(item.id);
                            }
                            const initialData = _.cloneDeep(InitialInventoryData);
                            return {
                                ...initialData, ...item,
                                placement_id: item.id,
                                disabled: disabled,
                            } as IInventory;
                        })
                        .sort((a: IInventory, b: IInventory) => {
                            if (a.disabled && !b.disabled) return 1;
                            if (!a.disabled && b.disabled) return -1;
                            return a.name < b.name ? -1 : 1;
                        });
                    })
                    .catch((err: AxiosError)=>{
                        if (err.response && (err.response as AxiosResponse).status !== 200) {
                            this.$notify.error(feedbackTerms.other.getResponse.error.fail);
                        } else {
                            this.$notify.error(err.message);
                        }
                        throw err;
                    })
    }
    private getAdsetData():Promise<any>{
        return this.$http.adserverAPI.post('GetAdsetInfo', {
            adset_ids: this.currentAdset.idList,
        })
    }

    private getCampaignData(campaignID: ID_TYPE){
        return this.$http.adserverAPI.post('GetCampaignInfo', {
            campaign_id: campaignID,
        });
    }

    private getInventoryData(appKey: ID_TYPE) {
        return this.$http.adserverAPI.post('GetSSPPlacementList', {
            app: [appKey],
        })
    }
    
    private async created() {
        await this.initData();
        if (!this.isEdit) {
            try {
                await this.clearCurrentAdset()
            } catch (err) {
                switch (err.type) {
                    case campaignStoreErr.CLEAR_CURRENT_ADSET:
                        this.$notify.error({
                            title: feedbackTerms.new.error.clearCurrentAdset.title,
                            message: feedbackTerms.new.error.clearCurrentAdset.message,
                        });
                        this.$router.push({
                            name: 'adset', 
                            params: {campaignID: this.currentCampaign.id.toString()},
                        });
                        return;
                        break;
                }
                throw err;
            }
        }
    }
}
